import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { SearchService } from '@services/search.service';
import { GlobalService } from '@common/global';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CreateService } from '@services/create.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-pquestion',
  templateUrl: './pquestion.component.html',
  styleUrls: ['./pquestion.component.sass']
})
export class PquestionComponent implements OnInit {

  //@Input() productid: string;

  @Input('c') component: string;
  @Input('a') application: string;
  @Input('rows') rows: number;
  @Input('mediaId') mediaId: string;
  @Input('mediaType') mediaType: string;
  @Input('mediaName') mediaName: string;
  @Input('loginurl') loginurl: string;
  btn_process=false;
  topicList: any = [];
  dataLoding = true;
  topic_count = 0;
  params: any = [];
  pageCounter=1;
  isLogin=false;
  questionForm: FormGroup;
  form_renter = false;
  topic_error: any = {  "name": "" };
  constructor( private _createService: CreateService,private fb: FormBuilder, private _searchService: SearchService, private _global: GlobalService) {

    if (this._global.isAuthenticated()) {
      this.isLogin = true;
    }
    this.questionForm = this.fb.group({
      name: []
    });
   }

  ngOnChanges() {
    if (this.mediaId) {
      this.list();
    }
  }

  ngOnInit() {
  }
  list() {

    let p = {
      'component': this._global.COMPONENTS_SMN,
      'application': 'topic',
      'sortOrder': 'desc',
      'sortString': 'createdTime',
      entityId: this.mediaId,
      "start": 0,
      "rows": this.rows
    };
    this._searchService.application(p).subscribe(
      topicList => {
        this.dataLoding=false;
        if (!_.isEmpty(this._global.getVal(topicList, 'response.docs', ''))) {
          this.params = this._global.getVal(topicList, 'request', {});
          this.topic_count = this._global.getVal(topicList, 'response.numFound', '0');
          this.topicList = this._global.getVal(topicList, 'response.docs', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }
  onScrollDown() {
    if (!this.dataLoding) {
      this.dataLoding = true;
      if (this.topic_count <= this.pageCounter * this.rows) {
        this.dataLoding = false;
      } else {
        let p = this._global.generateParams(this.params, ['component', 'start', 'language', 'url', 'dialect']);
        p['start'] = this.pageCounter * this.rows;
        p['component'] = this.component;
        this._searchService.appreview(p).subscribe(
          data => {
            if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
              this.topicList = this.topicList.concat(this._global.getVal(data, 'response.docs', []));
              this.dataLoding = false;
              this.pageCounter += 1;
              this.params = this._global.getVal(data, 'request', '');
            } else {
              this.dataLoding = false;
            }
          },
          error => {
            console.log("error", JSON.stringify(error));
          });

      }
    }
  }

  saveTopic() {
   
    this.topic_error = {  "name": "" };
    this.btn_process = true;
    let p = this.questionForm.value;
    p = this._global.paramsRemoveNull(p);
    p['entityId'] = this.mediaId
    p['application'] = 'topic';
    p['component'] = this.component;
    p['entityType'] = this.mediaType;
    p['status'] = 'active';
    this._createService.topic(p).subscribe(
      data => {
        this.btn_process = false;
        if (data["status"] == "1") {
          let msg="Question create success";//this._global.getVal(data, 'message.info', '')
          this._global.showMessage({ "type": 'success', "message": msg });
          let r=this.topicList;
          this.topicList=[];
          this.topicList.push(data["response"]);
          this.topicList = this.topicList.concat(r);
          this.questionForm.reset();
          this.form_renter = false;
        } else {
          for (let key in data["errors"]) {
            if(key=='name'){
              this.topic_error[key] =" Question cannot be empty.";
            }else{
            this.topic_error[key] = data["errors"][key]["message"];
            }
          }
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
}
